export const QA_NAME_AI_TEXT_GENERATION_FIELD = 'ai_text_generation_field'

export const AITextGenerationFieldMode = {
  Draft: 'draft',
  Field: 'field',
}

export const AITextGenerationApplyAction = {
  Apply: 'apply',
  InsertBelow: 'insertBelow',
  Replace: 'replace',
}

export const AI_TEXT_GENERATION_COPY_RESET_TIMEOUT = 5000

export const AI_NOTICE_HTML_STYLE =
  'color:var(--secondary-text-color-70);font-size:16px;line-height:24px;letter-spacing:0.5px;'
